import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";

interface RoomCardPriceProps {
  price: number;
  currencyLabel: string;
}

export default function RoomCardPrice({
  price,
  currencyLabel,
}: RoomCardPriceProps) {
  return (
    <Flex alignItems={"center"} gap={"1"}>
      <Typography
        variant={"h3"}
        fontWeight={"semibold"}
        className="text-primary"
      >
        {price.toLocaleString()}
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={"semibold"}
        className="text-primary"
      >
        {currencyLabel}
      </Typography>
    </Flex>
  );
}
